export default "__VITE_ASSET__DG2C3T3w__"